export default class HydrogeologicalEntityItem {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
    }
}